import CustomHeader from 'components/ReusableComponents/HeaderTitles'

const UsageStats = () => {
  return (
    <div>
      <CustomHeader title={'Usage stats'} width={1132} />
      <div
        dangerouslySetInnerHTML={{
          __html: `<iframe plausible-embed src="https://plausible.io/share/dashboard.directful.com?auth=kQe2oDnKEUxk2izWZrG_-&embed=true&theme=light&background=transparent" scrolling="no" frameborder="0" loading="lazy" style="width: 1px; min-width: 100%; height: 3000px;"></iframe>
        <script async src="https://plausible.io/js/embed.host.js"></script>`
        }}
      />
    </div>
  )
}

export default UsageStats
